var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex flex-col justify-center items-center pt-10" },
    [
      _vm.title
        ? _c(
            "div",
            [
              _vm._t("title", function () {
                return [
                  _c(
                    "p",
                    { staticClass: "font-normal text-base text-storm-gray" },
                    [_vm._v(" " + _vm._s(_vm.title) + " ")]
                  ),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._t("subtitle", function () {
        return [
          _c(
            "p",
            {
              staticClass:
                "text-base font-normal text-storm-gray mb-4 text-center",
              class: _vm.customStyle,
            },
            [_vm._v(" " + _vm._s(_vm.subtitle) + " ")]
          ),
        ]
      }),
      _vm._t("default"),
      _vm.$scopedSlots.image
        ? _c("div", { staticClass: "w-1/2 pt-2 h-96" }, [_vm._t("image")], 2)
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }